import React from 'react';
import { Trans } from 'react-i18next';

import { IconActionLink, IconActionLinkDark } from '@/assets/stream';
import { openNewWindow, withHttp } from '@/utils';
import { useQueryParams, useTheme } from '@/hooks';

import { ActionWrapper, ActionProps } from './Wrapper';
import style from './index.module.scss';

export const LinkVisit = (props: ActionProps) => {
  const { data: action } = props;
  const [privateToken] = useQueryParams<string>('private_token');
  const { isDark } = useTheme();

  const handleClick = () => {
    let link = `/link?redirect=${withHttp(action?.data?.action_url!)}&action_id=${action?.id}`;
    if (privateToken) {
      link = `${link}&private_token=${privateToken}`;
    }
    openNewWindow(link);
  };

  return (
    <ActionWrapper
      {...props}
      disabledFetchVisit
      onActionClick={handleClick}
      avatar={
        <img
          src={isDark ? IconActionLinkDark : IconActionLink}
          className={style.actionIcon}
          alt="action"
        />
      }>
      <Trans i18nKey="QuestCard_consts.visit" values={{ page: action.data.name || '' }} />
    </ActionWrapper>
  );
};
